"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QRCodeBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const QRCodeBody_style_1 = require("./QRCodeBody.style");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const react_1 = require("react");
function QRCodeBody({ onChange, validate }) {
    const [isValid, setIsValid] = (0, react_1.useState)(null);
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const handleInputChange = (0, react_1.useCallback)((value) => {
        setIsValid(validate(value));
        onChange(value);
    }, [onChange, validate]);
    return ((0, jsx_runtime_1.jsx)(QRCodeBody_style_1.StyledContainer, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { name: 'url', id: 'qr-code-url', type: 'url', label: t('tool.qrcode.url'), placeholder: t('tool.qrcode.enter_url'), errorMessage: isValid === false ? t('tool.qrcode.invalid_url') : undefined, onChange: handleInputChange }) }));
}
exports.QRCodeBody = QRCodeBody;
//# sourceMappingURL=QRCodeBody.js.map